import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Header,
  FormField,
  Input,
  Button,
  Alert,
  SpaceBetween,
  Box,
} from "@cloudscape-design/components";
import { useAuth } from "../context/AuthContext";
import { authService } from "../services/authService";

export default function ChangePassword() {
  const { clearPasswordChangeRequired, logout } = useAuth();
  const history = useHistory();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const companylogo = process.env.REACT_APP_CLIENT_LOGO || "/Assets/images/iWMS.png";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }
    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters.");
      return;
    }
    if (newPassword === currentPassword) {
      setError("New password must be different from current password.");
      return;
    }

    setLoading(true);
    try {
      await authService.changePassword(currentPassword, newPassword);
      clearPasswordChangeRequired();
      history.push("/");
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to change password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <SpaceBetween size="l">
          <Box textAlign="center">
            <img src={companylogo} alt="Company Logo" style={{ height: 50, marginBottom: 16 }} />
            <h1 style={styles.logo}>iWMS SmartOps</h1>
            <p style={styles.subtitle}>Password Change Required</p>
          </Box>

          <Container header={<Header variant="h2" description="Your account requires a password change before you can continue.">Set New Password</Header>}>
            <form onSubmit={handleSubmit}>
              <SpaceBetween size="m">
                {error && <Alert type="error">{error}</Alert>}

                <Alert type="info">
                  For security, you must set a new password before accessing the system.
                </Alert>

                <FormField label="Current (Temporary) Password">
                  <Input
                    type="password"
                    value={currentPassword}
                    onChange={({ detail }) => setCurrentPassword(detail.value)}
                    placeholder="Enter temporary password"
                    autoFocus
                  />
                </FormField>

                <FormField label="New Password">
                  <Input
                    type="password"
                    value={newPassword}
                    onChange={({ detail }) => setNewPassword(detail.value)}
                    placeholder="At least 6 characters"
                  />
                </FormField>

                <FormField label="Confirm New Password">
                  <Input
                    type="password"
                    value={confirmPassword}
                    onChange={({ detail }) => setConfirmPassword(detail.value)}
                    placeholder="Re-enter new password"
                  />
                </FormField>

                <Button variant="primary" formAction="submit" loading={loading} fullWidth>
                  Set New Password
                </Button>

                <Box textAlign="center">
                  <Button variant="link" onClick={() => { logout(); history.push("/login"); }}>
                    Cancel and log out
                  </Button>
                </Box>
              </SpaceBetween>
            </form>
          </Container>
        </SpaceBetween>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0f1b2d 0%, #1b2f4b 100%)",
  },
  card: {
    width: "100%",
    maxWidth: 440,
    padding: "0 16px",
  },
  logo: {
    color: "#fff",
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
    letterSpacing: 1,
  },
  subtitle: {
    color: "rgba(255,255,255,0.6)",
    marginTop: 4,
    fontSize: 14,
  },
};
